/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseLeadChangeResponse } from '../../models/base-lead-change-response';
import { SetBaseLeadRequest } from '../../models/set-base-lead-request';

export interface SetBaseCrewLead$Params {
  id: number;
      body: SetBaseLeadRequest
}

export function setBaseCrewLead(http: HttpClient, rootUrl: string, params: SetBaseCrewLead$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseLeadChangeResponse>> {
  const rb = new RequestBuilder(rootUrl, setBaseCrewLead.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseLeadChangeResponse>;
    })
  );
}

setBaseCrewLead.PATH = '/api/scheduler/bases/{id}/base-lead';
